
export const TICKETS = [100, 500, 1000, 5000, 25000, 100000];
export const DEFAULT_TICKET = TICKETS[0];

export type { RushMidPayout as Payout } from '@cs-shot/battle-sim';
